<template>
    <a-card>
      
    <div>
        <h3 style="text-align: center;margin:20px 0 40px">预期目标</h3>
        <a-form layout="vertical"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules" >
            <!--可编辑区域 start-->
            <div class="hidden">
                <!-- <div > -->
                <a-col :span="24">
                    <a-form-item label="ID主键" name="id">
                        <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目ID" name="projectId">
                        <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="分类ID" name="classification">
                        <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                    </a-form-item>
                </a-col>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="项目转化推广实施前规模" name="beforeImplementation">
                        <a-textarea v-model:value="form.beforeImplementation" placeholder="请输入项目转化推广实施前规模" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目转化推广实施后规模" name="afterImplementation">
                        <a-textarea v-model:value="form.afterImplementation" placeholder="请输入项目转化推广实施后规模" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目实施后达到的技术、经济指标" name="specificationEconomic">
                        <a-textarea v-model:value="form.specificationEconomic" placeholder="请输入项目实施后达到的技术、经济指标" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="项目实施后实现的社、会生态效益" name="benefit">
                        <a-textarea v-model:value="form.benefit" placeholder="请输入项目实施后实现的社、会生态效益" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="实现销售收入(万元)" name="income">
                        <a-input-number style="width:100%" v-model:value="form.income" placeholder="请输入实现销售收入(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="其中：创汇收入(万元)" name="exchangeIncome">
                        <a-input-number style="width:100%" v-model:value="form.exchangeIncome" placeholder="请输入创汇收入(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="实现利润(万元)" name="profit">
                        <a-input-number style="width:100%" v-model:value="form.profit" placeholder="请输入实现利润(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="实现税金(万元)" name="realizeTaxes">
                        <a-input-number style="width:100%" v-model:value="form.realizeTaxes" placeholder="请输入实现税金(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="转化推广示范基地预期规模，带动相关产业及示范效应" name="example">
                        <a-textarea v-model:value="form.example" placeholder="请输入转化推广示范基地预期规模，带动相关产业及示范效应" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="验收内容" name="acceptanceContent">
                        <a-checkbox-group v-model:value="form.acceptanceContent">
                            <a-checkbox v-for="(item,key) in optionCheck" :key="key" :value="item.value" name="type">{{item.name}}</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="text-align: center;">
                    <a-button type="primary" html-type="submit" @click="onSubmit">
                        预期目标保存
                    </a-button>
                </a-col>
            </a-row>
        </a-form>
        
    </div>
    </a-card>
</template>
<script>
import { postAction, postJson } from "@/utils/http/service";
import { filterObj } from "@/utils/util";
import store from '@/store';
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {projectExpectations} from "@/api/TechnologieprojekteApply";

export default {
    name: "预期目标",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            optionCheck:[{
                name:'技术报告',
                value:'0'
            },{
                name:'计算机软件',
                value:'1'
            },{
                name:'生物品种',
                value:'2'
            },{
                name:'样品或样机',
                value:'3'
            },{
                name:'成套技术设备',
                value:'4'
            }],
            form: {
                    id: null,
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                    beforeImplementation: null,
                    afterImplementation: null,
                    specificationEconomic: null,
                    benefit: null,
                    income: null,
                    profit: null,
                    exchangeIncome: null,
                    realizeTaxes: null,
                    example: null,
                    acceptanceContent: null,
            },
            rules: {
                    id: [],
                    projectId: [
                        dataCheck.required({}),
                    ],
                    classification: [
                        dataCheck.required({}),
                    ],
                    beforeImplementation: [
                        dataCheck.required({}),
                    ],
                    afterImplementation: [
                        dataCheck.required({}),
                    ],
                    specificationEconomic: [
                        dataCheck.required({}),
                    ],
                    benefit: [
                        dataCheck.required({}),
                    ],
                    income: [
                        dataCheck.required({type:"number"}),
                    ],
                    profit: [
                        dataCheck.required({type:"number"}),
                    ],
                    exchangeIncome: [
                        dataCheck.required({type:"number"}),
                    ],
                    realizeTaxes: [
                        dataCheck.required({type:"number"}),
                    ],
                    example: [
                        dataCheck.required({}),
                    ],
                    acceptanceContent: [
                    ]
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                return projectExpectations.saveOrUpdate
            }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }
    },
    methods: {
        /*提交表单操作*/
        onSubmit() {
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                    this.form.acceptanceContent = this.form.acceptanceContent.toString()
                    console.log(this.form.acceptanceContent)
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            this.$parent.$parent.postData(res.data.classification,res.data.projectId)
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$parent.$parent.errorSet()
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                        }
                        window.console.log('error', error);
                    });
            }
        },
        onEdit() {
            this.getAction({
                url: projectExpectations.detailByProject,
                params: { 
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                 }
            }).then(res => {
                if(res){
                    this.form = res
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
</style>
